import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export enum StatsTab {
  Home = "home",
  Reports = "reports",
  Stipends = "stipends",
}

type CurrentStatsTabState = {
  tab: StatsTab;
  setTab: (tab: StatsTab) => void;
};

export const useCurrentStatsTab = create<CurrentStatsTabState>()(
  devtools(
    persist(
      (set) => ({
        tab: StatsTab.Home,
        setTab: (tab) => set({ tab }),
      }),
      {
        name: "current-stats-tab",
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);
